import React from "react";

function Separator() {
  return <hr className="mb-10 border-t border-gray-300 bg-light border-0" />;
}

export default Separator;
